import { SidekickTheme } from "@avenue-8/sidekick-ui";

export const generateEditorContentStyle = (theme: SidekickTheme) => `
  h1 {
    font-family: ${theme.title.fonts.primary};
    font-size: ${theme.title.fontSizes.h1};
    font-weight: 700;
    color: ${theme.title.colors.primary};
    margin-top: 0;
    margin-bottom: 1.5rem;
    line-height: 1.2;
  }

  h2 {
    font-family: ${theme.title.fonts.primary};
    font-size: ${theme.title.fontSizes.h2};
    font-weight: 700;
    color: ${theme.title.colors.primary};
    margin-top: 0;
    margin-bottom: 1.25rem;
    line-height: 1.3;
  }

  h3 {
    font-family: ${theme.title.fonts.primary};
    font-size: ${theme.title.fontSizes.h3};
    font-weight: 700;
    color: ${theme.title.colors.primary};
    margin-top: 0;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  h4 {
    font-family: ${theme.title.fonts.primary};
    font-size: ${theme.title.fontSizes.h4};
    font-weight: 700;
    color: ${theme.title.colors.primary};
    margin-top: 0;
    margin-bottom: 1rem;
    line-height: 1.4;
  }

  h5 {
    font-family: ${theme.title.fonts.primary};
    font-size: ${theme.title.fontSizes.h5};
    font-weight: 700;
    color: ${theme.title.colors.primary};
    margin-top: 0;
    margin-bottom: 0.75rem;
    line-height: 1.4;
  }

  h6 {
    font-family: ${theme.title.fonts.primary};
    font-size: ${theme.title.fontSizes.h6};
    font-weight: 700;
    color: ${theme.title.colors.primary};
    margin-top: 0;
    margin-bottom: 0.75rem;
    line-height: 1.4;
  }

  p {
    font-family: ${theme.text.fonts.primary};
    font-size: ${theme.text.fontSizes.l};
    color: ${theme.text.colors.primary};
    font-weight: 400;
    line-height: 1.6;
    margin-bottom: 1rem;
  }

  a {
    color: ${theme.link.colors.primary};
    text-decoration: underline;
    
    &:hover {
      color: ${theme.link.colors.hover};
    }
  }

  ul, ol {
  padding-left: 0;
    list-style-position: inside;
    margin-bottom: 1rem;
    color: ${theme.text.colors.primary};
  }

  li {
    font-family: ${theme.text.fonts.primary};
    font-size: ${theme.text.fontSizes.l};
    color: ${theme.text.colors.primary};
    line-height: 1.6;
    margin-bottom: 0.25rem;
  }

  .text-editor-body {
    width: calc(100% - 3rem);
    max-width: 520px;
    margin: auto;
    padding: 1.5rem;
  }

  // TinyMCE toolbar button
  .tox-tbtn {
    max-width: 100px !important;
  }
`;
